import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getWebContent } from "../../services/epic/bloodDonation";
import { Helmet } from 'react-helmet';
import { Loader } from "../../common/Loader";
import { getLayoutDirection } from "../../utils/util";
import DOMPurify from "dompurify";

const BloodDonationCenter = () => {
  const { webStructurePk, templateId } = useParams();
  const [isLoading] = useState(false);

  useEffect(() => {
    getWebContent(webStructurePk, templateId)
    .then((result) => {
      const element = document.querySelector("#bloodDonationCenter");
      const sanitizedContent = DOMPurify.sanitize(result?.data);
      element.innerHTML = sanitizedContent;
      if (result?.data) {
        carousel();
      }
    })
    .catch((error) => {


      //console.error("Error fetching web content:", error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    });window.parent.scrollTo(0, 0);}, []);

  function carousel() {
    carousel1();
    carousel2();
  }
  function carousel1() {
    const carousel = document.querySelector(".customBdProcessCarousel");
    const items = document.querySelectorAll(".customBdProcessCarousel .item");
    const dotsContainer = document.querySelector(".slider-dots");

    // Assign data-index dynamically
    items.forEach((item, index) => {
      item.setAttribute("data-index", index + 1);
    });

    // Create dots dynamically
    items.forEach((item, index) => {
      const dot = document.createElement("span");
      dot.classList.add("dot");
      if (index === 0) dot.classList.add("active");
      dot.dataset.index = index;
      dotsContainer.appendChild(dot);
    });

    const dots = document.querySelectorAll(".slider-dots .dot");

    function updateActiveItem() {
      let closestIndex = 0;
      let minDistance = Math.abs(items[0].offsetLeft - carousel.scrollLeft);

      items.forEach((item, index) => {
        const distance = Math.abs(item.offsetLeft - carousel.scrollLeft);
        if (distance < minDistance) {
          minDistance = distance;
          closestIndex = index;
        }
      });

      items.forEach((item, index) => {
        item.classList.toggle("active", index === closestIndex);
        dots[index].classList.toggle("active", index === closestIndex);
      });
    }

    // Scroll event
    carousel.addEventListener("scroll", updateActiveItem);

    // Click on dots
    dots.forEach((dot) => {
      dot.addEventListener("click", () => {
        const index = dot.dataset.index;
        const item = items[index];
        carousel.scrollTo({
          left: item.offsetLeft - carousel.offsetLeft,
          behavior: "smooth"
        });
      });
    });

    updateActiveItem();
  }
  function carousel2() {
    var carousel = document.querySelector(".healthCardCarousel");
    var items = document.querySelectorAll(".healthCardCarousel .item");
    var dotsContainer = document.querySelector(".healthCardSliderDots");

    // Assign data-index dynamically
    items.forEach((item, index) => {
      item.setAttribute("data-index", index + 1);
    });

    // Create dots dynamically
    items.forEach((item, index) => {
      var dot = document.createElement("span");
      dot.classList.add("dot");
      if (index === 0) dot.classList.add("active");
      dot.dataset.index = index;
      dotsContainer.appendChild(dot);
    });

    var dots = document.querySelectorAll(".healthCardSliderDots .dot");

    var updateActiveItem = () => {
      var closestIndex = 0;
      var minDistance = Math.abs(items[0].offsetLeft - carousel.scrollLeft);

      items.forEach((item, index) => {
        var distance = Math.abs(item.offsetLeft - carousel.scrollLeft);
        if (distance < minDistance) {
          minDistance = distance;
          closestIndex = index;
        }
      });

      items.forEach((item, index) => {
        item.classList.toggle("active", index === closestIndex);
        dots[index].classList.toggle("active", index === closestIndex);
      });
    };

    // Scroll event
    carousel.addEventListener("scroll", updateActiveItem);

    // Click on dots
    dots.forEach((dot) => {
      dot.addEventListener("click", () => {
        var index = dot.dataset.index;
        var item = items[index];
        carousel.scrollTo({
          left: item.offsetLeft - carousel.offsetLeft,
          behavior: "smooth"
        });
      });
    });

    updateActiveItem();
  }

  if (isLoading)
  {
    return (
      <Loader />);

  }

  return (
    <>
      <Helmet>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.7.1/jquery.min.js"></script>
      </Helmet>
      <div className={` custombody_color ${getLayoutDirection()}`}>
      <div id="bloodDonationCenter"></div>
      </div>
    </>);

};

export default BloodDonationCenter;